import { TimeSpanParam } from "./LeftArgumentTypes";
export class DelayTask {
    constructor() {
        this.Delay = new TimeSpanParam('00:00:00');
    }
}
export class NotifyTask {
    constructor() {
        /**
         * Message to be sent to the client
         * We can use here special variable patterns like {channelId:StateInterfaceName} to replace this with last state value, eq. {f945b230-cbb8-4dc0-ae0a-a85866467872_1:IChannelOnOff} will be replaced with 'on' or 'off' depending on the last state of the channel
         */
        this.Message = "";
        this.NotifyType = NotifyType.None;
        this.NotificationClients = [];
    }
}
export var NotifyType;
(function (NotifyType) {
    NotifyType[NotifyType["None"] = 0] = "None";
    NotifyType[NotifyType["AppNotification"] = 1] = "AppNotification";
    NotifyType[NotifyType["Email"] = 2] = "Email";
})(NotifyType || (NotifyType = {}));
export class LockExecutionTask {
    constructor() {
        this.LockType = LockType.Timeout;
        this.LockStartHour = new TimeSpanParam("00:00:00");
        this.LockEndHour = new TimeSpanParam("00:00:00");
        this.ResetLockScenesGuids = [];
    }
}
export var LockType;
(function (LockType) {
    LockType[LockType["Timeout"] = 0] = "Timeout";
    LockType[LockType["TimeRange"] = 1] = "TimeRange";
})(LockType || (LockType = {}));
//# sourceMappingURL=SceneTaskTypes.js.map